<template>
  <div v-if="loginStatus" class="styleBlue" id="app">
    <div id="header">
      <el-col :span="8" class="height-100">
        <div id="logo" class="height-100 f-a-c">
          <img src="./assets/logo.png" width="44" />
          <div v-if="user && user.authorizer_list.length > 1" @click="selectCurrent = currentApp['id']; changeCustomer = true" class="margin-left-11 switch-customer" style="margin-left:-2px;">
            <p class="bi-name">
              荧识 INSERV SCRM 应用管理平台
              <el-tooltip class="item" effect="dark" placement="top" v-show="currentApp.type === 'mp'">
                <div slot="content">
                  该公众号接入时间为：{{currentApp.create_time}}<br/>
                  图文数据为账号开始使用至今所有数据汇总，其它数据自接入平台后开始统计。
                </div>
                <i class="fa el-icon-info gray80"></i>
              </el-tooltip>
            </p>
            <p class="bi-app-name">
              {{currentApp['nick_name']}} - {{currentApp["type"] == "mp" ? "公众号" : (currentApp["type"] == "sp" ? "小程序" : (currentApp["type"] == "jd" ? "京东租户" : "管理员"))}}
              <span class="fa fa-caret-down"></span>
            </p>
          </div>
          <div v-else class="margin-left-11">
            <p class="bi-name">荧识 INSERV SCRM 应用管理平台</p>
            <p class="bi-app-name">
              {{currentApp['nick_name']}} - {{currentApp["type"] == "mp" ? "公众号" : (currentApp["type"] == "sp" ? "小程序" : (currentApp["type"] == "jd" ? "京东租户" : "管理员"))}}</p>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="height-100" align="center"></el-col>
      <el-col :span="8" class="height-100">
        <div class="f-a-c j-c-e bi-user-wrap height-100">
          <div id="userinfo">
            <el-dropdown size="small" trigger="click">
              <span class="el-dropdown-link">
                <img src="./assets/user-icon.png"/>
              </span>
              <el-dropdown-menu slot="dropdown" class="header-drop">
                <el-dropdown-item>
                  <el-button type="text" @click="logoutDialogVisible = true">
                    <span class="fa fa-sign-out"></span>
                    退出登录
                  </el-button>
                  </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-col>
    </div>
    <div id="main">
      <div id="sidebar" class="sidebar">
        <menu-temp-new :defaultActive="defaultActive" :menu="menu"></menu-temp-new>
      </div>
      <div id="content" ref="content">
        <router-view></router-view>
      </div>
    </div>
    <el-dialog title="账户选择" v-if="user" :visible.sync="changeCustomer" class="phone-d">
      <el-form label-width="80px" size="small" class="account-box">
        <el-form-item v-if="authType['mp'] === true" prop="current" label="公众号">
          <el-radio-group v-model="selectCurrent">
            <template v-for="(item, index) in user.authorizer_list">
              <el-radio border v-if="item.type === 'mp'" :label="item.authorizer_id" name="current" class="mg-radio" :key="index">{{item.name}}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="authType['sp'] === true" prop="current" label="小程序">
          <el-radio-group v-model="selectCurrent">
            <template v-for="(item, index) in user.authorizer_list">
              <el-radio border v-if="item.type === 'sp'" :label="item.authorizer_id" name="current" class="mg-radio" :key="index">{{item.name}}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="authType['app'] === true" prop="current" label="APP">
          <el-radio-group v-model="selectCurrent">
            <template v-for="(item, index) in user.authorizer_list">
              <el-radio border v-if="item.type === 'app'" :label="item.authorizer_id" name="current" class="mg-radio" :key="index">{{item.name}}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item v-if="authType['jd'] === true" prop="current" label="京东租户">
          <el-radio-group v-model="selectCurrent">
            <template v-for="(item, index) in user.authorizer_list">
              <el-radio border v-if="item.type === 'jd'" :label="item.authorizer_id" name="current" class="mg-radio" :key="index">{{item.name}}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item v-if="authType['system'] === true" prop="current" label="管理员">
          <el-radio-group v-model="selectCurrent">
            <template v-for="(item, index) in user.authorizer_list">
              <el-radio border v-if="item.type === 'system'" :label="item.authorizer_id" name="current" class="mg-radio" :key="index">{{item.name}}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeCustomer = false" size="small">取 消</el-button>
        <el-button type="primary" @click="changeCustomerSubmit" size="small">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提醒" :visible.sync="logoutDialogVisible">
      <span>确认退出登录？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logoutDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="logoutSubmit" size="small" :loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
  <div v-else class="login" id="app">
    <!-- <div class="login-content">
      <h3 class="login-title">荧识 INSERV SCRM 应用管理平台</h3>
      <el-form :model="loginForm" :rules="loginFormRules" ref="loginForm" @keyup.enter.native="loginSubmit" size="small">
        <el-form-item prop="username">
          <el-input type="text" v-model.trim="loginForm.username" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" v-model.trim="loginForm.password" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="btnLoading" @click="loginSubmit">登录</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    <div v-if="$route.path === '/login'">
      <router-view></router-view>
    </div>
    <div class="check-box styleBlue" v-else>

      <div class="login-content" v-if="checkStatus === -1">
        <h3 class="login-title">开通申请</h3>
        <el-form :model="checkForm" :rules="checkFormRules" ref="checkFormRef" @keyup.enter.native="regUser" size="small">
          <el-form-item prop="name">
            <el-input type="text" v-model.trim="checkForm.name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item prop="company">
            <el-input type="text" v-model.trim="checkForm.company" placeholder="公司名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="btnLoading" @click="regUser">确定</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="checkStatus === 0" class="check-status-box">
        <i class="el-icon-position font36 color-blue"></i><br>
        <span>您的申请正在审核中</span>
      </div>

      <div v-if="checkStatus === 2" class="check-status-box">
        <i class="el-icon-warning-outline font36 colorred"></i><br>
        <span>您的申请未通过</span>
      </div>

      <div v-if="checkStatus === 3" class="check-status-box">
        <i class="el-icon-folder-delete font36 gray66"></i><br>
        <span>您的申请已关闭</span>
      </div>

      <div v-if="checkStatus === 1001" class="check-status-box">
        <i class="el-icon-warning-outline font36 color-yellow"></i><br>
        <span>未配置权限，请联系管理员</span>
      </div>
      
    </div>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'
import { Auth } from '@/model'
import { MenuTempNew } from '@/views/common'
import Config from './conf'
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      currentApp: {
        nick_name: '',
        id: ''
      },
      loginStatus: false,
      checkStatus: null,
      defaultActive: '',
      loginForm: {
        username: '',
        password: ''
      },
      loginFormLoading: false,
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ]
      },
      user: '',
      changeCustomer: false,
      selectCurrent: '',
      logoutDialogVisible: false,
      authType: {},
      btnLoading: false,
      menu: '',
      checkForm: {
        token: '',
        name: '',
        company: ''
      },
      checkFormRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'change' }
        ]
      },
      accessRoute: []
    }
  },
  components: {
    MenuTempNew
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ])
  },
  methods: {
    // async logoutSubmit () {
    //   this.btnLoading = true
    //   let res = await Auth.logout()
    //   this.btnLoading = false
    //   if (res['err_code']) {
    //     this.$message.error(res['err_msg'])
    //   } else {
    //     this.logoutDialogVisible = false
    //     this.$cookie.delete(Config['token_key'])
    //     this.$cookie.delete(Config['current_key'])
    //     this.loginStatus = false
    //     window.location.href = '/'
    //   }
    // },
    // async logoutSubmit () {
    //   const jsonp = require('jsonp')
    //   this.btnLoading = true
    //   jsonp('https://login.jdcloud.com/logout', null, (err, data) => {
    //     if (err) {
    //       console.error(err.message)
    //     } else {
    //       console.log(data)
    //       if (!data.code) {
    //         this.logoutDialogVisible = false
    //         this.$cookie.delete(Config['token_key'])
    //         this.$cookie.delete(Config['current_key'])
    //         this.loginStatus = false
    //         window.location.href = '/'
    //       }
    //     }
    //     this.btnLoading = false
    //   })
    // },
    async logoutSubmit () {
      const jsonp = require('jsonp')
      jsonp('https://login.jdcloud.com/logout', null, (err, data) => {
        console.log(err, data)
        this.getOauthUrl()
      })
      // const jsonp = require('jsonp')
      // this.btnLoading = true
      // jsonp('https://login.jdcloud.com/logout', null, (err, data) => {
      //   if (err) {
      //     console.error(err.message)
      //   } else {
      //     console.log(data)
      //     if (!data.code) {
      //       this.logoutDialogVisible = false
      //       this.$cookie.delete(Config['token_key'])
      //       this.$cookie.delete(Config['current_key'])
      //       this.loginStatus = false
      //       window.location.href = '/'
      //     }
      //   }
      //   this.btnLoading = false
      // })
    },
    async loginSubmit () {
      this.btnLoading = true
      let res = await Auth.login(this.loginForm)
      this.btnLoading = false
      if (res['err_code'] !== 0) {
        this.$message.error(res['err_msg'])
      } else {
        this.$cookie.set(Config['token_key'], res['data']['token'])
        this.getUserInfo()
        this.$message({
          message: '登录成功！',
          type: 'success'
        })
      }
    },
    async getUserInfo () {
      let res = await Auth.getUserInfo({'authorizer': this.$cookie.get(Config['current_key'])})
      if (res['err_code'] === 0 && res['data']['user']) {
        res['data']['authorizer']['service_type_info'] = res['data']['authorizer'].service_type_info ? JSON.parse(res['data']['authorizer'].service_type_info) : ''
        res['data']['authorizer']['verify_type_info'] = res['data']['authorizer'].verify_type_info ? JSON.parse(res['data']['authorizer'].verify_type_info) : ''
        res['data']['authorizer']['business_info'] = res['data']['authorizer'].business_info ? JSON.parse(res['data']['authorizer'].business_info) : ''
        res['data']['authorizer']['func_info'] = res['data']['authorizer'].func_info ? JSON.parse(res['data']['authorizer'].func_info) : ''
        this.user = res['data']['user']
        this.$store.dispatch('authorizer', res['data']['authorizer'])
        res['data']['user']['admin'] = !!res['data']['user']['authorizer_list'].find(item => { return item['authorizer_id'] === 'admin'})
        this.$store.dispatch('user', res['data']['authorizer'])
        res['data']['user']['authorizer_list'].map(item => {
          this.authType[item.type] = true
        })
        this.currentApp = res['data']['authorizer']
        this.$cookie.set(Config['current_key'], this.currentApp['id'])
        this.selectCurrent = this.currentApp['id']
        let has = res['data']['user']['authorizer_list'].find(item => item['authorizer_id'] === this.currentApp['id'])
        this.menu = has['module']
        // if (this.$route.path === '/') {
        //   let path = ''
        //   for (let k in this.menu) {
        //     path = '/' + k + '/' + this.menu[k][0]
        //     break
        //   }
        //   this.$router.replace(path)
        // }
        let routeArray = []
        for (let key in this.menu) {
          for (let k in this.menu[key]) {
            routeArray.push.apply(routeArray, this.sidebar[key][this.menu[key][k]])
          }
        }
        routeArray.push('/login')
        this.accessRoute = routeArray
        // console.log('this.$route.path', this.$route.path)
        if (!this.verifyRouter(this.$route.path)) {
          this.$router.replace(routeArray[0])
        }
        // setTimeout(() => {
        this.defaultActive = this.$route.path
        // }, 200)
        this.loginStatus = true
      } else {
        if (res['err_code'] === 1001) {
          this.checkStatus = res['err_code']
        } else {
          this.$message.error(res['err_msg'])
        }
        this.loginStatus = false
      }
    },
    verifyRouter (path) {
      if (this.accessRoute.indexOf(path) > -1) {
        return true
      }
      return false
    },
    changeCustomerSubmit () {
      this.$cookie.set(Config['current_key'], this.selectCurrent)
      window.location.href = '/'
    },
    async checkUserInfo (token) {
      let res = await Auth.checkUserInfo({
        token: token
      })
      // alert(JSON.stringify(res))
      if (!res.err_code) {
        if (res.data.status === 1) { // 已通过
          // this.$cookie.set(Config['current_key'], token)
          this.getUserInfo()
          if (this.$route.path === '/login') {
            this.$router.replace('/')
          }
        } else {
          this.checkStatus = res.data.status
        }
        //  else if (res.data.status === 0) { // 审核中

        // } else if (res.data.status === 2) { // 未通过

        // } else if (res.data.status === 3) { // 已关闭

        // }
      } else {
        this.getOauthUrl()
        this.$message.error(res.err_msg)
      }
    },
    async getOauthUrl () {
      this.$cookie.delete(Config['token_key'])
      this.$cookie.delete(Config['current_key'])
      let res = await Auth.getOauthUrl()
      if (!res.code) {
        // console.log(res)
        if (window.location.href.search('inserv.matrix.jdcloud.com') != -1) {
          // console.log(11)
          window.location.href = 'https://login.jdcloud.com/?returnUrl=' + encodeURI(res['data']['oauth_url'])
        } else {
          // console.log(22)
          window.location.href = window.location.protocol + '//' + window.location.host + '/#login'
          // window.location.href = window.location.protocol + '//' + window.location.host + '/#/login'
          window.location.reload()
        }
      } else {
        this.$message.error(res.err_msg)
      }
    },
    regUser () {
      this.$refs['checkFormRef'].validate((valid) => {
        if (valid) {
          this.checkSubmit()
        } else {
          // console.log('error submit!!');
          return false;
        }
      })
    },
    async checkSubmit () {
      this.btnLoading = true
      let res = await Auth.regUser({
        token: this.$cookie.get(Config['token_key']),
        name: this.checkForm.name,
        company: this.checkForm.company
      })
      if (!res.err_code) {
        this.checkStatus = 0
      } else {
        this.$message.error(res.err_msg)
      }
      this.btnLoading = false
    }
  },
  created () {
    this.$router.onReady(() => {
      // var token = this.$cookie.get(Config['token_key'])
      // if (token && token !== 'undefined') {
      //   this.checkUserInfo(token)
      // } else {
      //   this.$cookie.delete(Config['token_key'])
      //   this.$cookie.delete(Config['current_key'])
      //   this.loginStatus = false
      //   let search = window.location.search ? this.util.deserialize(window.location.search.replace('?', '')) : ''
      //   let token = search && search.token
      //   if (token) {
      //     this.$cookie.set(Config['token_key'], token)
      //     delete search['token']
      //     let params = this.util.serialize(search)
      //     window.location.href = window.location.origin + '/' +  params + window.location.hash
      //   } else {
      //     this.getOauthUrl()
      //   }
      // }
      // 
      

      let search = window.location.search ? this.util.deserialize(window.location.search.replace('?', '')) : ''
      let token = search && search.token
      if (token) {
        this.$cookie.delete(Config['current_key'])
        this.$cookie.set(Config['token_key'], token)
        delete search['token']
        let params = this.util.serialize(search)
        window.location.href = window.location.origin + '/' +  params + window.location.hash
      } else {
        let token = this.$cookie.get(Config['token_key'])
        if (token && token !== 'undefined') {
          this.checkUserInfo(token)
        } else {
          this.$cookie.delete(Config['token_key'])
          this.$cookie.delete(Config['current_key'])
          if (this.$route.path !== '/login') {
            this.getOauthUrl()
          }
        }
      }
    })
    this.$router.afterEach((to, from) => {
      this.defaultActive = this.$route.path
    })
    this.$router.beforeEach((to, from, next) => {
      // console.log(1, to.path)
      if (this.verifyRouter(to.path)) {
        this.$store.state.charts = []
        // qq浏览器没有scrollto方法
        // document.getElementById('content').scrollTo(0, 0)
        // let content = document.getElementById('content')
        // if (content) {
        //   content.scrollTop = 0
        // }
        next()
      } else {
        this.$message({
          message: '无权限进入该模块！',
          type: 'warning'
        })
        this.$router.replace(from.path)
      }
    })
  },
  mounted () {
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
body,html,#app {
  width: 100%;
  height: 100%;
  font-family: Roboto,Helvetica Neue,"PingFang SC","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-size: 82%;
  overflow-x: hidden;
  overflow-y: hidden;
  color: #606266;
}
a{
  text-decoration: none;
}
.alink{
  color: #409EFF;
}
.adelete{
  color: red;
}
.login {
  width: 100%;
  height: 100%;
  background: #1F2D3D;
  position: relative;
}
.check-box {
  width: 100%;
  height: 100%;
  position: relative;
}
.check-status-box {
  text-align:center;
  margin-top: 300px;
  line-height: 40px;
}
.check-status-box span {
  color: #666;
}
.login-content {
  background-clip: padding-box;
  background-color: #f9fafc;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 rgba(0,0,0,.35);
  margin-bottom: 20px;
  padding: 35px 35px 15px;
  width: 280px;
  position: absolute;
  top: 20%;
  left: 50%;
  margin-left: -175px;
}
.login-title {
  color: #505458;
  margin: 0 auto 40px;
  text-align: center;
}
#app {
  font-size: 14px;
  overflow: hidden;
  background-color: #F5F5F5;
}
#header {
  background-color: #FAFAFA;
  min-width: 100%;
  color: rgba(0,0,0,0.87);
  position: relative;
  z-index: 1;
  height: 64px;
  /*box-shadow: 0 0 5px 0 rgba(0,0,0,.35);*/
  border-bottom: 1px solid #F0F0F0;
}
.bi-name{
  color: #7E7E7E;
  font-size: 14px;
  line-height: 16px;
}
.bi-app-name{
  color: #4A4A4A;
  font-size: 16px;
  line-height: 22px;
}
.bi-user-wrap div{
  text-align: right;
}
.header-drop{
  background: #fafafa!important;
}
.header-drop .el-button--text{
  color: rgba(0,0,0,0.87)!important;
  font-size: 14px;
  font-weight: 400;
}
#logo {
  font-size: 22px;
}
#logo img {
  margin-left: 20px;
}
#logo .txt {
  margin-top: 10px;
}
.back-up {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 9;
}
.arrowAni {
  animation: myArrow .2s steps(1,end) infinite;
}
@keyframes myArrow {
  0% {background: url("assets/back-up.png") no-repeat scroll -298px 0 transparent;}
  25% {background: url("assets/back-up.png") no-repeat scroll -447px 0 transparent;}
  50% {background: url("assets/back-up.png") no-repeat scroll -596px 0 transparent;}
  75% {background: url("assets/back-up.png") no-repeat scroll -745px 0 transparent;}
  100% {background: url("assets/back-up.png") no-repeat scroll -149px 0 transparent;}
}
.arrowAniNone {
  animation: myArrowNone .5s;
}
@keyframes myArrowNone {
  0% {top: 80%}
  100% {top: -30%}
}
#userinfo {
  cursor: pointer;
  text-align: right;
}
#userinfo .el-dropdown {
  margin-right: 20px;
}
#userinfo img {
  margin: 10px 0 10px 0;
  vertical-align: middle;
}
#content {
  padding: 15px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  position: relative;
}
#main {
  display: flex;
  justify-content: center;
  overflow: hidden;
  height: calc(100% - 65px);
  width: 100%;
}
#main-wrap{
  width: 100%;
  box-sizing: border-box;
  min-width: 1010px;
  display: flex;
  justify-content: center;
  position: absolute;
  left: 0px;
  top: 15px;
}
.account-box .el-radio {
  margin-right: 0;
  margin-bottom: 10px;
  margin-left: 10px;
}
.sidebar {
  /*background-color: #fff;
  height: 100%;
  transition: all 0.5s;
  box-shadow: 0 0 5px 0 #F0F0F0;*/
  background: #fff;
  height: 100%;
  /*width: 26%;*/
  width: 255px;
  max-width: 300px;
  min-width: 240px;
  /*overflow: hidden;*/
  border-right: 1px solid #f0f0f0;
  overflow-y: auto;
}

.c-title{
  font-size: 18px;
  font-weight: 300;
  line-height: 18px;
  letter-spacing: 0;
  color: #4A4A4A;
  line-height: 14px;
}
.c-inner-title{
  font-size: 20px;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: 0;
  margin-top: 10px;
  text-indent: 5px;
  color: #4A4A4A;
}
/* 翻页 */
.main-page {
  text-align: right;
  padding: 0 15px 15px 0;
}
/* table */
.table-wrap {
  padding: 15px;
  background: #fff;
  border-radius: 3px;
  /*box-shadow: 0 2px 3px hsla(0, 0%, 4%, 0.1), 0 0 0 1px hsla(0, 0%, 4%, 0.1);*/
}
.table-control {
  padding-bottom: 10px;
}
/* 小型设备（平板电脑，768px 起） */
@media (max-width: 768px) {
  .box-main .box-col-join{
    width: 100%!important;
  }
}

/* el导航 */
#sidebar .el-menu {
  border-right: none;
}
.sidebar > ul {
  margin-top: 30px;
}
.sidebar i {
  font-size: 14px;
}
.sidebar i.c-icon {
  width: 16px;
  margin: 0;
}
.sidebar div {
  box-sizing: border-box;
}
.sidebar > .el-menu > div > div li i.fa, .sidebar .el-submenu__title i.fa {
  margin-left: 18px;
}
.sidebar > .el-menu > div > div li span, .sidebar .el-submenu__title span {
  margin-left: 20px;
}
.sidebar .el-submenu .el-menu-item, .sidebar .el-submenu__title div {
  text-indent: 34px;
}
.sidebar .el-menu .el-menu .el-submenu .el-menu-item {
  text-indent: 14px;
}
.sidebar .el-menu div div .el-submenu .el-menu div li .el-submenu__title span {
  margin-left: 34px;
}
.styleBlue .sidebar .el-menu .line {
  width: 100%;
  height: 1px;
  overflow: hidden;
  background: #f0f0f0;
  margin: 20px 0;
}
#sidebar .el-menu .el-submenu .el-submenu .el-menu-item {
  height: 40px!important;
  line-height: 40px!important;
}
#sidebar .el-menu-item, .el-submenu__title, #sidebar .el-submenu .el-menu-item, #sidebar .el-menu--inline .el-submenu .el-submenu__title {
  height: 45px!important;
  line-height: 45px!important;
}
.sidebar ul ul {
  padding: 5px 0;
}
.styleBlue #sidebar .el-submenu__title i,
.styleBlue #sidebar .el-submenu__title span,
.styleBlue #sidebar .el-menu-item,
.styleBlue #sidebar .el-menu-item i,
.styleBlue #sidebar .el-menu-item span {
  color: #aeaeae!important;
}
.styleBlue #sidebar .el-submenu .el-submenu .el-menu-item {
  color: #B3B3B3!important;
  font-weight: 200;
}
.styleBlue #sidebar .is-active > i,
.styleBlue #sidebar .is-active > span,
.styleBlue #sidebar .is-active > div > i,
.styleBlue #sidebar .is-active > div > span,
.styleBlue #sidebar .el-submenu__title:hover i,
.styleBlue #sidebar .el-submenu__title:hover span,
.styleBlue #sidebar .el-menu .el-menu-item:hover,
.styleBlue #sidebar .el-menu .el-menu-item:hover i,
.styleBlue #sidebar .el-menu .el-menu-item:hover span,
.styleBlue #sidebar .el-menu .el-menu-item.is-active,
.styleBlue #sidebar .el-submenu .el-submenu .el-menu-item.is-active {
  color: #399CFB!important;
}

/*start common*/
.auto {
  height: auto;
  overflow: hidden;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.m-tb-5{
  margin: 5px 0;
}
.m-tb-10{
  margin: 10px 0;
}
.m-tb-15{
  margin: 15px 0;
}
.m-lr-5{
  margin: 0 5px;
}
.m-rb-5{
  margin: 0 5px 5px 0;
}
.m-r-5{
  margin-right: 5px;
}
.m-t-10{
  margin-top: 10px;
}
.m-t-15 {
  margin-top: 15px;
}
.m-b-5{
  margin-bottom: 5px;
}
.m-l-5{
  margin-left: 5px;
}
.m-l-15{
  margin-left: 15px;
}
.m-r-10 {
  margin-right: 10px;
}
.m-r-20 {
  margin-right: 20px;
}
.m-15 {
  margin: 15px;
}
.m-t-30 {
  margin-top: 30px;
}
.m-30 {
  margin: 30px;
}
.m-10 {
  margin: 10px;
}
.height-100{
  height: 100%;
}
.h-cursor{
  cursor: pointer;
}
.p-15 {
  padding: 15px;
}
.p-10 {
  padding: 10px;
}
.p-tb-15 {
  padding: 15px 0;
}
.p-tb-10 {
  padding: 10px 0;
}
.p-30 {
  padding: 30px;
}
.p-none{
  padding: 0!important;
}
.alignR {
  text-align: right;
}
.alignC {
  text-align: center;
}
.alignL {
  text-align: left;
}
.font36{
  font-size: 36px;
}
.font30{
  font-size: 30px;
}
.font26{
  font-size: 26px;
}
.font20{
  font-size: 20px;
}
.font18{
  font-size: 18px;
}
.font16{
  font-size: 16px;
}
.font14{
  font-size: 14px;
}
.font12{
  font-size: 12px;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.clear {
  width: 100%;
  height: 0px;
  overflow: hidden;
  clear: both;
}
.ellipsis{
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*end common*/

/* color */
.color-red{
  color: #f56c6c!important;
}
.styleBlue .black {
  color: #000;
}
.styleBlue .red {
  color: red;
}
.styleBlue .blue {
  color: #409EFF;
}
.styleBlue .color-blue {
  color: #409EFF;
}
.styleBlue .color-yellow {
  color: #E6A23C;
}
.styleBlue .green {
  color: #50d166;
}
.styleBlue .grayae {
  color: #aeaeae;
}
.styleBlue .grayce {
  color: #cecece;
}
.styleBlue .grayccc {
  color: #ccc;
}
.styleBlue .grayb3 {
  color: #b3b3b3;
}
.styleBlue .gray66 {
  color: #666;
}
.styleBlue .gray75 {
  color: #757575;
}
.styleBlue .gray99 {
  color: #999;
}
.styleBlue .gray80 {
  color: #808080;
}
.styleBlue .colorred {
  color: #e74a59;
}
.styleBlue .colorblue {
  color: #50bfff;
}

/* background */
.styleBlue .black-bg {
  background-color: #000;
}
.styleBlue .blue-bg {
  background-color: #4e81ed;
}
.styleBlue .gray66-bg {
  background-color: #666;
}
.styleBlue .gray75-bg {
  background-color: #757575;
}
.styleBlue .gray99-bg {
  background-color: #999;
}

/* box-style */
.bigbox {
  background: #fff;
  border-radius: 5px;
}
.box-block-10 {  /*适用于模块的外层DIV*/
  margin: 10px;
}
.box-block-20 {
  margin: 20px;
}
.box-block-title {
  margin: 0 20px;
}
.box-item {  /*适用于模块的内层DIV*/
  margin: 20px;
}
.box-item-inside {  /*适用于模块内list*/
  margin: 0px 20px 20px 0px;
}
.box-item-outside {  /*适用于模块外list*/
  margin: 10px 10px 10px 0px;
}

/* 盒模型 */
.boxsizing {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.flex-box{
  display: flex;
}
.j-c-e{
  justify-content: flex-end;
}
.j-c-c{
  justify-content: center;
}
.j-c-b{
  justify-content: space-between;
}
.j-c-a{
  justify-content: space-around;
}
.f-a-c{
  display: flex;
  align-items: center;
}
.flex-basis-40{
  flex-basis: 40%;
}
.flex-basis-15{
  flex-basis: 15%;
}
.flex-basis-50{
  flex-basis: 50%;
}

/*内容概览对比弹框取消全选功能*/
.checkedTable .el-table__header-wrapper .el-checkbox{
  display: none;
}
.screenDialog .el-tag{
  width: 19%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  position: relative;
  padding-right: 20px;
  margin-right: 8px;
}
.screenDialog .el-tag .el-icon-close{
  position: absolute;
  right: 5px;
  top: 50%;
  margin-top: -8px;
}
.screenDialog .el-select{
  width: 100%;
}

/*table*/
.el-table td, .el-table th{
  padding: 10px 0!important;
}
.el-table{
  font-size: 12px!important;
}

/*behaviorTable*/
#tabletemp.behaviorTable{
  border: none;
}
#tabletemp.behaviorTable tr th, #tabletemp.behaviorTable tr td{
  border-right: none;
}
#tabletemp.behaviorTable tr th{
  background: none;
}
#tabletemp.behaviorTable tr:last-child th{
  border-bottom: 1px solid #ccc;
}
#tabletemp.behaviorTable table tr th{
  font-size: 14px!important;
}
#tabletemp.behaviorTable.el-table--border::after, #tabletemp.behaviorTable.el-table--group::after, #tabletemp.behaviorTable.el-table::before{
  background: none;
}

/*图片上传样式-单张*/
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
i.el-icon-plus.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/*外链图文*/
.replyDialog .el-dialog__body{
  padding: 0 20px;
}
.maxWidthRadio .el-radio-button__inner{
  width: 100%;
}

.right-dialog .el-dialog{
  float: right;
  margin-bottom: 0;
}

/*色盘插件样式*/
.vc-container {
  z-index: 999;
}

/*element切换标签改造-开始*/
.radio-group-nobg .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background: #fff;
  border-color: #dcdfe6;
  box-shadow: none;
  color: #399CFB!important;
}
.radio-group-nobg .el-radio-button__inner,
.radio-dates-picker-nobg .el-input__inner,
.radio-dates-picker-nobg .el-range-editor .el-range-input,
.radio-dates-picker-nobg .el-date-editor .el-range-separator {
  background: none;
  color: #b3b3b3;
}
.radio-dates-picker-nobg .el-date-editor .el-range-input {
  width: 80px;
}
.radio-dates-picker-nobg .el-date-editor--daterange.el-input,
.radio-dates-picker-nobg .el-date-editor--daterange.el-input__inner,
.radio-dates-picker-nobg .el-date-editor--timerange.el-input,
.radio-dates-picker-nobg .el-date-editor--timerange.el-input__inner {
  width: 240px;
}
/*element切换标签改造-结束*/

/*element下拉框改造-开始*/
.selsect-group-nobg .el-input__inner {
  background: none;
  color: #b3b3b3;
}
/*element下拉框改造-结束*/

/*element切换栏目改造-开始*/
.tabs-column .el-tabs--border-card>.el-tabs__header {
  background-color: #fff;
  border-bottom: none!important;
}
.tabs-column .el-tabs--border-card {
  box-shadow: none;
  border: none;
  border-radius: 5px;
  overflow: hidden;
}
.tabs-column .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  border-color: #f5f5f5;
  border-bottom: none;
  padding: 0 50px!important;
}
.tabs-column .el-tabs--border-card>.el-tabs__header {
  border-color: #f5f5f5;
}
.tabs-column .el-tabs--border-card>.el-tabs__header .el-tabs__item {
  transition: none;
}
.tabs-column .el-tabs__item {
  color: #808080;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  padding: 0 50px!important;
  font-weight: 300;
}
.edit-tabs-column .el-tabs--border-card>.el-tabs__header { /*content_hub编辑器样式调整*/
  border-bottom: none!important;
}
.edit-tabs-column .ql-toolbar.ql-snow {
  border: none!important;
  border-bottom: 1px solid #f5f5f5!important;
}
.edit-tabs-column .ql-toolbar.ql-snow+.ql-container.ql-snow {
  border: none!important;
}
/*用户详情私有属性*/

/*element切换栏目改造-结束*/

/*小程序部分loading位置恢复-开始*/
.miniwarp .el-loading-spinner{
  top: 50%!important;
}
/*小程序部分loading位置恢复-结束*/

#contentinput textarea.el-textarea__inner {
  width: 100%;
  height: 350px;
  padding: 50px 10px 10px;
  line-height: 20px;
  font-size: 14px;
  resize: none;
  font-family: Roboto,Helvetica Neue,"PingFang SC","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
.local_text a{
  color: #409EFF;
  text-decoration: underline;
}
.previewbox.mpreplytext a {
  color: #409EFF;
  text-decoration: underline;
}

/*公用素材选择组件element组件改造*/
.editTextarea textarea {
  border: none;
  border-bottom: 1px solid #eee;
  resize: none;
  border-radius: 0;
}

/*素材展示组件样式整理*/
.materialshowbox .textbox a {
  color: #4285f4;
}

/*个性菜单发布样式调整*/
.menu-release-form .el-form-item__label {
  text-align: left;
}

/*content_hub文章列表页手机预览样式-开始*/
.content_hub .content_editor {
  height: calc(100vh - 210px);
  overflow-y: auto;
  border: 1px solid #eee;
  padding: 20px 0;
}
.content_hub .content_editor img {
  max-width: 100%;
  display: block;
}
.content_hub .content_editor audio {
  width: 100%;
  display: block;
}
.content_hub .content_editor video {
  width: 100%;
  display: block;
}
.content_hub .content_add {
  width: 100px;
  float: left;
  margin: 96px 0 0 15px;
}
.content_hub .content_add ul {
  width: 100%;
  border: 1px solid #eee;
  border-bottom: none;
}
.content_hub .content_add ul li {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
  text-indent: 10px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
}
.content_hub .content_add ul li:hover {
  background: #ecf5ff;
}
.content_hub .content_add ul li i {
  margin-right: 5px;
}
.content_hub .choose {
  border-color: #409EFF;
}
.content_hub .content_row_text.ql-editor {
  min-height: auto;
}
.content_hub .content_row_text,
.content_hub .content_row_img,
.content_hub .content_row_imggroup_poster,
.content_hub .content_row_imggroup_slider,
.content_hub .content_row_video,
.content_hub .content_row_mini,
.content_hub .content_row_voice {
  padding: 5px;
}
.content_hub .content_row {
  position: relative;
  border: 1px solid #fff;
  border-radius: 5px;
  margin: 0 5px!important;
  line-height: 24px;
  color: #333;
}
.content_hub .tagsbox span {
  margin-right: 10px;
}
.content_hub .list-box {
  padding: 10px;
  background: #fff;
  border-radius: 5px;
  break-inside: avoid;
  box-sizing: border-box;
  height: auto;
  overflow: hidden;
}
.content_hub .texttitle {
  line-height: 20px;
  border-bottom: 1px solid #eee;
  padding: 5px 0 10px;
}
.content_hub .textbox {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  margin: 10px 0;
}
.content_hub .textbox img {
  width: 100%;
}
.content_hub .minibox {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 15px;
  height: auto;
  overflow: hidden;
}
.content_hub .minibox dl dt {
  width: 100%;
  border-bottom: 1px solid #eee;
  line-height: 24px;
  font-size: 14px;
}
.content_hub .minibox dl dd {
  margin: 15px 0;
  width: 100%;
  position: relative;
  height: auto;
  overflow: hidden;
}
.content_hub .minibox dl dd img {
  width: 100%;
  display: block;
}
.content_hub .minibox dl dd img:nth-child(2) {
  position: absolute;
  left: 0;
  top: 0;
}
.content_hub .imgminibox {
  padding: 5px;
}
.content_hub .imgminibox dl dt {
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAb1BMVEUAAAB4it11h9x2h9x2h9x2htx8j+R8i+B1h9x2h9x3h92Snv91htt2h9x1h9x4h9x1h9x1h9x2idx1h9t2h9t1htt1h9x1h9x1htx2h9x1h912h9x4h913iN17juOOjuN1iNx2h9t4h958i+B1htvejBiPAAAAJHRSTlMALPLcxKcVEOXXUgXtspU498sx69DPu5+Yc2JeRDwbCYuIRiGBtoolAAAA3ElEQVQoz62S1xKDIBBFWYiFYImm2DWF///G7DJEROOb58U79zi4O8iOo8zuCRfV8EdFgbYE49qFQs8ksJInajOA1wWfYvLcGSueU/oUGBtPpti09uNS68KTMcrQ5jce4kmN/HKn9XVPAo702JEdx9hTUrWUqVrI3KwUmM1NhIWMKdwiGvpGMWZOAj1PZuzAxHwhVSplrajoseBnbyDHAwvrtvKKhdqTtFBkL8wO5ijcsS3G1JMNvQ5mdW7fc0x0+ZcnlJlZiflAomdEyFaM7qeK2JahEjy5ZyU7jC/q/Rz/DgqEuAAAAABJRU5ErkJggg==') no-repeat left center;
  background-size: auto 60%;
  text-indent: 20px;
}
.content_hub .minibox p {
  font-size: 12px;
  color: #999;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAb1BMVEUAAAB4it11h9x2h9x2h9x2htx8j+R8i+B1h9x2h9x3h92Snv91htt2h9x1h9x4h9x1h9x1h9x2idx1h9t2h9t1htt1h9x1h9x1htx2h9x1h912h9x4h913iN17juOOjuN1iNx2h9t4h958i+B1htvejBiPAAAAJHRSTlMALPLcxKcVEOXXUgXtspU498sx69DPu5+Yc2JeRDwbCYuIRiGBtoolAAAA3ElEQVQoz62S1xKDIBBFWYiFYImm2DWF///G7DJEROOb58U79zi4O8iOo8zuCRfV8EdFgbYE49qFQs8ksJInajOA1wWfYvLcGSueU/oUGBtPpti09uNS68KTMcrQ5jce4kmN/HKn9XVPAo702JEdx9hTUrWUqVrI3KwUmM1NhIWMKdwiGvpGMWZOAj1PZuzAxHwhVSplrajoseBnbyDHAwvrtvKKhdqTtFBkL8wO5ijcsS3G1JMNvQ5mdW7fc0x0+ZcnlJlZiflAomdEyFaM7qeK2JahEjy5ZyU7jC/q/Rz/DgqEuAAAAABJRU5ErkJggg==') no-repeat left center;
  text-indent: 20px;
  background-size: auto 60%;
}
.editorbox.content_hub {
  width: 300px;
  margin: 0 auto;
  height: auto;
  position: relative;
  float: none;
}
.editorbox.content_hub img.iphonex {
  width: 100%;
  display: block;
}
.editorbox.content_hub .content_editor {
  border: none;
  position: absolute;
  left: 6.5%;
  top: 13%;
  width: 87%;
  height: 80%;
}
.editorbox.content_hub .content_editor::-webkit-scrollbar { /*滚动条整体样式*/
  width: 10px;
  height: 1px;
}
.editorbox.content_hub .content_editor::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background: #535353;
}
.editorbox.content_hub .content_editor::-webkit-scrollbar-track { /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  border-radius: 10px;
  background: #EDEDED;
}
.content_hub .phonetitle {
  margin: 0 10px;
  padding: 15px 0;
}
.content_hub .phonetitle .title {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
.content_hub .phonetitle .titleinfo {
  font-size: 12px;
}
.content_hub .phonetitle .titleinfo span {
  margin-right: 10px;
}
.content_hub .imgGroupPreview {
  width: 350px;
  margin: 0 auto;
}
.content_hub .imgGroupPreview ul li {
  width: 350px;
}
.content_hub .imgGroupPreview img {
  width: 100%;
  display: block;
}
.content_hub .imggroupbox {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.content_hub .imggroupbox ul {
  position: relative;
  display: block;
  display: flex;
  left: 0;
  transition: left .5s;
  align-items: center
}
.content_hub .imggroupbox ul li {
  width: 100%;
}
.content_hub .imggroupbox ul li img {
  align-items: center
}
/*content_hub文章列表页手机预览样式-结束*/

/*dashboard样式-开始*/
.dashboard-footerbox .el-input__inner {
  border: none;
  width: 90px;
  height: 30px;
  line-height: 30px;
  padding-left: 0;
}
/*dashboard样式-结束*/

/*用户详情弹窗手风琴样式*/
.dialogrightbot .el-collapse-item__header {
  background: rgba(220, 220, 220, .1);
}
.usersorcetitlebox span.el-tag--mini {
  float: left;
}
.usersorcetitlebox span.el-tag--mini span.el-select__tags-text {
  float: left;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.userfilterscustom .el-tabs--border-card>.el-tabs__content {
  padding: 10px 0;
}
.user-tabs-column .el-tabs__nav-scroll {
  /*border-bottom: 1px solid #eee;*/
  background: #f5f7fa;
}

.swiper-container-horizontal>*>.slider-pagination-bullet {
  background: #409EFF!important;
  opacity: .5!important;
}
.swiper-container-horizontal .slider-pagination-bullet-active, .swiper-container-vertical .slider-pagination-bullet-active {
  background: #409EFF!important;
  opacity: 1!important;
}
.el-image-viewer__close {
  color: #fff;
}

/*用户筛选显示内el-tabs样式修改*/
.user-filter-show .el-tabs__header {
  margin-bottom: 0;
}
.user-filter-show .el-tabs__content {
  border-left: 1px solid #E4E7ED;
  border-right: 1px solid #E4E7ED;
}
.filter-box {
  flex: 1;
}

/*模板消息群发穿梭框*/
.custom-transfer .el-transfer-panel {
  width: 300px!important;
}
.custom-transfer .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
  font-size: 14px;
}
.custom-transfer .el-transfer-panel__item.el-checkbox {
  display: block;
}

.jd-filter-box>div {
  width: 100%;
}
.jd-filter-box .el-tabs {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.jd-filter-box .el-tabs>div.el-tabs__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.jd-filter-box .el-tabs>div.el-tabs__content>div {
  flex: 1;
}
.jd-filter-box .tabpan-box {
  height: 100%!important;
}
.jd-filter-box .el-tab-pane .active {
  color: #409EFF;
}
</style>
